import React, { useMemo } from 'react';

import {
	useClassNames,
} from '@common';

import './Switch.scss';

interface switchProps {
	titleDisable?: string,
	onChange: () => void,
	titleEnable?: string,
	className?: string,
	value: boolean,
	disabled?: boolean,
}

function Switch(props: switchProps): JSX.Element {
	const {
		titleDisable,
		titleEnable,
		className,
		onChange,
		value,
		disabled,
	} = props;

	const title = useMemo((): string => {
		return value ? titleEnable : titleDisable;
	}, [value, titleEnable, titleDisable]);

	const classes = useClassNames(
		'switch',
		className,
	);

	const label_classes = useClassNames(
		'switch__label',
		disabled && 'switch__label_disabled'
	)

	return (
		<div className={classes} onClick={() => !disabled && onChange()}>
			<input
				className="switch__input"
				name="switch-input"
				checked={value}
				type="checkbox"
				readOnly
			/>
			<label className={label_classes} htmlFor="switch-input">
				<div className="switch__fake" title={title}>
					<div className="switch__dot" />
				</div>
			</label>
		</div>
	);
}

const Memoisedswitch = React.memo(Switch);

export {Memoisedswitch as Switch};